export const DEFAULT_ITEMS_PER_PAGE = 12;
export const DEFAULT_PAGE_NUMBER = 1;
export const OFFSET_FROM_END = 5;
